import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, Renderer2, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'frg-button',
  templateUrl: './button.fragment.html',
  styleUrls: ['./button.fragment.scss']
})
export class ButtonFragment implements AfterViewInit {

  @ViewChild('buttonElement') public buttonElement: ElementRef;

  _backgroundColor = 'var(--darkest-primary)';
  get backgroundColor(): string {
    return this._backgroundColor;
  }
  @Input() set backgroundColor(value: string) {
    this._backgroundColor = value;
    if (this.buttonElement) {
      this.buttonElement.nativeElement.style.backgroundColor = value;
    }
  }

  @Input() public fontColor = 'var(--white)';
  @Input() public disabled = false;
  @Input() public type = 'button';
  @Input() public fullWidth = false;

  @Output()
  public activated = new EventEmitter();

  constructor(
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef
  ) { }

  ngAfterViewInit(): void {
    this.buttonElement.nativeElement.style.backgroundColor = this.backgroundColor;
    this.buttonElement.nativeElement.style.color = this.fontColor;

    if (this.fullWidth) {
      this.renderer.addClass(this.buttonElement.nativeElement, 'full-width');
      this.renderer.addClass(this.viewContainerRef.element.nativeElement, 'full-width');
    }
  }

  public active(): void {
    if (!this.disabled) {
      this.activated.emit();
    }
  }

}
